export default "__VITE_ASSET__BYKNxYS1__"